import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import WebsiteLayout from '@layouts/WebsiteLayout'
import Button from '@components/shared/Button'
import Seo from '@components/shared/Seo'
import { PageProps } from 'gatsby'

const NotFoundPage: FC<PageProps> = ({ location }) => {
  const [mounted, setMounted] = useState(false)

  // Add this mounting effect to prevent flickering of the 404 page
  // on MEWOZ pages due to hosting limits of their GCP
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <></>
  }

  return (
    <WebsiteLayout
      articleHero={{
        title: 'Pagina niet gevonden',
      }}
    >
      <Seo title="Eerlijke WOZ - Pagina niet gevonden" />
      <p style={{ fontSize: '1.125rem' }}>
        Oeps... De pagina kan niet worden gevonden, gebruik het hoofdmenu om verder te gaan of onderstaande knop om
        terug te keren naar de homepagina.
      </p>
      <p>
        <Button url={'/'}>Naar homepagina</Button>
      </p>
    </WebsiteLayout>
  )
}

export default NotFoundPage

